/**
 * Copyright (c) 2018, salesforce.com, inc.
 * All rights reserved.
 * Licensed under the BSD 3-Clause license.
 * For full license text, see LICENSE.txt file in the repo root or
 * https://opensource.org/licenses/BSD-3-Clause
 */
import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';

const Button = styled.button`
  display: inline-block;
  border: solid 1px transparent;
  ${(p) => p.round && 'border-radius: .25rem;'}
  ${(p) => p.circle && 'border-radius: 50%;'}
  ${(p) => p.circle && 'padding: .25rem;'}

  background-color: ${(p) => p.bgColor || 'inherit'};

  line-height: 1;

  :focus {
    outline: 0;
    box-shadow: 0 0 3px #0070D2;
  }

  :hover {
    background-color: ${(p) => p.hoverBGColor ? p.hoverBGColor : '#0070D2'};
  }
`;

const SVG = styled.svg`
  height: ${(p) => p.size ? p.size : '1rem'};
  width: ${(p) => p.size ? p.size : '1rem'};
  fill: ${(p) => p.fill ? p.fill : '#FFFFFF'};
`;

/**
 * Icon Container for Standard SLDS Icons
 */
const CustomIconButton = ({ className, onClick, icon, size, bgColor, hoverBGColor, fill, round, circle }) => (
  <Button className={className} onClick={onClick} bgColor={bgColor} size={size} round={round} circle={circle}>
    <SVG size={size} bgColor={bgColor} hoverBGColor={hoverBGColor} fill={fill}>
      <use xlinkHref={`/assets/icons/custom-sprite/svg/symbols.svg#${icon}`}></use>
    </SVG>
  </Button>
);

CustomIconButton.propTypes = {
  className: PropTypes.string,
  onClick: PropTypes.func,
  href: PropTypes.string,
  bgColor: PropTypes.string,
};

CustomIconButton.defaultProps = {
  show: true,
};

export default CustomIconButton;
